import { render } from "./Get-Locations-view.vue?vue&type=template&id=76197079"
import script from "./Get-Locations-view.vue?vue&type=script&lang=js"
export * from "./Get-Locations-view.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__